export const AUTH_TYPES = {
    'EMAIL': 'EMAIL',
    'GOOGLE': 'GOOGLE',
    'MAGIC': 'MAGIC',
    'OTP': 'OTP',
    'NONE': 'NONE'
}
